import { render, staticRenderFns } from "./orderData.vue?vue&type=template&id=34f9e955&scoped=true"
import script from "./orderData.vue?vue&type=script&lang=js"
export * from "./orderData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f9e955",
  null
  
)

export default component.exports